/// <amd-module name="Environments/EnvironmentsSecurity/Constants" />
export class EnvironmentSecurityDialogConstants {
    public static readonly ManageRolePermissions: number = 16;
    public static readonly EnvironmentTokenPrefix: string = "Environments"
    public static readonly ReplaceableTokenSeperator: string = "_";
    public static readonly TfsServiceInstanceId: string = "00025394-6065-48CA-87D9-7F5672854EF7";
}

export class EnvironmentRoleScopes {
    public static readonly EnvironmentReferenceRoleScopeId: string = "distributedtask.environmentreferencerole";
    public static readonly GlobalEnvironmentReferenceRoleScopeId: string = "distributedtask.globalenvironmentreferencerole";
    public static readonly EnvironmentRoleScopeId: string = "distributedtask.environmentrole";
    public static readonly GlobalEnvironmentRoleScopeId: string = "distributedtask.globalenvironmentrole";
}

export const environmentSecurityUrl: string = "https://go.microsoft.com/fwlink/?linkid=2082587";